var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
/**
 * @hidden
 */
export var SLIDER_LABEL_ATTRIBUTE = 'data-slider-label';
/**
 * Represents the KendoReact SliderLabel component.
 */
var SliderLabel = /** @class */ (function (_super) {
    __extends(SliderLabel, _super);
    function SliderLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    SliderLabel.prototype.render = function () {
        var _a;
        var style = this.props.vertical
            ? { bottom: this.props.position + "%", height: '1px', width: '100%' }
            : { left: this.props.position + "%", width: '1px' };
        var labelTextStyle = this.props.vertical
            ? { top: '-8px' }
            : { width: '40px', left: "-20px" };
        return (React.createElement("li", { role: "presentation", className: "k-tick k-tick-large", title: this.props.title, style: __assign({ zIndex: 1, position: 'absolute' }, style) },
            React.createElement("span", __assign({ style: __assign({ position: 'absolute' }, labelTextStyle) }, (_a = {}, _a[SLIDER_LABEL_ATTRIBUTE] = true, _a), { className: "k-label", onClick: this.props.onClick }),
                " ",
                this.props.children)));
    };
    return SliderLabel;
}(React.PureComponent));
export { SliderLabel };
//# sourceMappingURL=SliderLabel.js.map